<template>
  <div v-loading="loading" class="main">
    <div class="each_main">
      <div class="record">税务进度</div>
      <div class="flex_between process">
        <div :class="{ active: progressInfo.invoiceStatus == 2 }">票</div>
        <div :class="{ active: progressInfo.taxStatus == 2 }">税</div>
        <div :class="{ active: progressInfo.payStatus == 2 }">缴</div>
        <div :class="{ active: progressInfo.gsStatus == 2 }">个税</div>
        <div :class="{ active: progressInfo.sbStatus == 2 }">社保</div>
        <div
          @click="sendNotice"
          :class="{
            active:
              progressInfo.sbStatus == 2 &&
              progressInfo.taxStatus == 2 &&
              progressInfo.payStatus == 2 &&
              progressInfo.gsStatus == 2,
          }"
        >
          完税
        </div>
      </div>
    </div>
    <div class="each_main" v-if="comInfo.automatic == 1">
      <div class="record">服务日程</div>
      <div class="fw_date" v-if="schedulInfo.djConfirmTimeOut">
        单据确认：单据超{{ schedulInfo.djConfirmTimeOut }}天未确认
      </div>
      <div class="fw_date" v-else-if="schedulInfo.skConfirmTimeOut">
        申报扣款确认：申报扣款超{{ schedulInfo.skConfirmTimeOut }}天未确认
      </div>
      <div class="fw_date" v-else-if="schedulInfo.kkConfirmTimeOut">
        扣款确认：扣款超{{ schedulInfo.kkConfirmTimeOut }}天未确认
      </div>
      <div v-else>
        <el-empty description="暂无待办日程" :image-size="80" />
      </div>
    </div>
    <div v-else class="each_main">
      <div class="record">服务日程</div>
      <el-empty description="暂无待办日程" :image-size="80" />
    </div>
    <div class="each_main">
      <div class="record">
        账务质检
        <!-- <div class="btn_right mr-8">
          预警：0 异常：0
        </div> -->
      </div>
      <div class="zj_content">
        <div class="flex_align_center">
          <el-progress type="circle" :percentage="qualityInfo.zjFs" width="80">
            <span>{{ qualityInfo.zjFs }}</span>
          </el-progress>
          <div class="zj_text">
            <div v-for="(item, index) in subject" :key="index">
              {{ item.name }}：{{ filterText(item.value, item.kf) }}
            </div>
          </div>
        </div>
        <div class="text_right">
          <el-button
            link
            size="small"
            @click="checkQuality"
            v-if="qualityInfo.zjLog?.length"
            >查看详情 》</el-button
          >
        </div>
      </div>
    </div>
    <div class="each_main" v-if="comForm.type == '1'">
      <div class="record">开票统计</div>
      <div class="fw_date">季度：{{ $comdify(invoiceInfo.outJdAmount) }}</div>
      <div class="fw_date">
        连续12个月：{{ $comdify(invoiceInfo.outYearAmount) }}
      </div>
    </div>
    <qualityData ref="qualityDataRef" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue"
import { ElLoading } from "element-plus"
import {
  taxProgress,
  serviceSchedule,
  accountingQuality,
  invoiceStatistics,
  doneTaxInfo,
} from "@/api/home"
import qualityData from "./components/qualityData.vue"
import { ElMessage } from "element-plus"
const props = defineProps({
  period: { type: String, default: "" },
  comInfo: { type: Object, default: () => {} },
  cKey: { type: Number, default: 0 },
})
const comId = ref(null)
const invoiceInfo = ref({
  outJdAmount: 0,
  outYearAmount: 0,
})
const period = ref()
const comForm = ref({})
const loading = ref(false)
const progressInfo = ref({
  gsStatus: 1,
  invoiceStatus: 1,
  payStatus: 1,
  sbStatus: 1,
  taxStatus: 1,
})
const schedulInfo = ref({
  isAutomatic: false,
  djConfirmTimeOut: 0,
  skConfirmTimeOut: 0,
  kkConfirmTimeOut: 0,
})
const qualityInfo = ref({
  zjFs: 0,
  zjLog: "",
})
const subject = ref([])
const qualityDataRef = ref()
const getList = async () => {
  let param = { comId: comId.value, period: period.value }
  loading.value = true
  subject.value = []
  await taxProgress(param).then((res) => {
    if (res.data.msg == "success") {
      progressInfo.value = res.data.data.info
    }
  })
  await serviceSchedule(param).then((res) => {
    if (res.data.msg == "success") {
      schedulInfo.value = res.data.data.info
    }
  })
  await accountingQuality(param).then((res) => {
    if (res.data.msg == "success") {
      qualityInfo.value = res.data.data.data
      if (res.data.data.data.zjLog) {
        qualityInfo.value.zjLog = JSON.parse(res.data.data.data.zjLog)
        parseValue(qualityInfo.value.zjLog)
        subject.value = subject.value.length ? subject.value.slice(0, 2) : []
      }
    }
  })
  if (comForm.value.type == "1") {
    await invoiceStatistics(param).then((res) => {
      if (res.data.msg == "success") {
        invoiceInfo.value = res.data.data.info
      }
    })
  }
  loading.value = false
}
const parseValue = (data) => {
  subject.value = []
  data?.forEach((v) => {
    const child = v.Child || []
    if (Array.isArray(child)) {
      switch (v.Name) {
        case "科目检查":
          processChild(child, subject.value)
          break
        default:
          break
      }
    }
  })
}
const processChild = (child, targetArray) => {
  child.forEach((k) => {
    let demo = k.split("#")
    targetArray.push({
      name: demo[0],
      value: demo[1],
      kf: demo[2],
    })
  })
}
const filterText = (text) => {
  if (text.includes("：")) {
    return text.substring(text.indexOf("：") + 1)
  }
  return text
}
//查看质检
const checkQuality = () => {
  qualityDataRef.value.init(comForm.value, qualityInfo.value.zjLog)
}
//发送完税通知
const sendNotice = () => {
  const loadingInstance = ElLoading.service({ text: "发送中，请稍后" })
  let param = { comId: comId.value, period: period.value }
  doneTaxInfo(param).then((res) => {
    loadingInstance.close()
    if (res.data.msg == "success") {
      wx.invoke(
        "sendChatMessage",
        {
          msgtype: "text", //消息类型，必填
          enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
          text: {
            content: res.data.data.info,
          },
        },
        function (res) {
          if (res.err_msg == "sendChatMessage:ok") {
            ElMessage.success("发送成功")
          }
        }
      )
      wx.invoke("sendChatMessage", {
        msgtype: "file", //消息类型，必填
        file: {
          mediaid: res.data.data.mediaId, //文件的素材id
        },
      })
    }
  })
}
watch(
  () => [props.period, props.comInfo, props.cKey],
  (newVal) => {
    period.value = newVal[0]
    comId.value = newVal[1].id
    comForm.value = newVal[1]
    if (comId.value) {
      getList()
    }
  },
  { immediate: true }
)
</script>

<style scoped lang="scss">
.main {
  padding: 0 5px;
  font-size: 14px;
}

.each_main {
  border: 1px solid #efefef;
  padding-top: 10px;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 10px;
}

.process {
  margin: 20px 8px;

  & > div {
    padding: 2px 10px;
    background-color: #afacac;
    color: #fff;
    border-radius: 4px;
    font-size: 13px;
  }

  .active {
    background-color: #67c23a;
  }
}

.fw_date {
  margin: 10px 8px 15px;
  font-size: 13px;
}

.mr-8 {
  margin-right: 8px;
}

.zj_content {
  margin: 0 8px 15px;
}

.zj_text {
  margin-left: 15px;
  font-size: 13px;
}
</style>
